module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/1/2-2f13889253cef13d6ef4363900d053ae.jpg";